import {ModelSegment} from "@lernetz/ui-components/src/stack/Stack";
import {WizardQuestion} from "./wizard.model";

export class WizardSegment extends ModelSegment {
    constructor(model: WizardQuestion) {
        super(model);
    }
    get view() {
        return "Wizard";
    }
    async resolve(urlSegment: string) {

        function compareAnswerIdToUrlSegment(answer) {
            try {
                if (answer.action) {
                    return answer.action.id === urlSegment;
                }
            } catch (error) {
                console.log(error);
                console.log("error with comparing the segment");
                console.log("urlSegment: " + urlSegment );
                console.log("answser.action.id: " +  answer.action.id );
            }
            return null;
        }

        const followUpQuestion = this.data.answers.find( compareAnswerIdToUrlSegment ).action;
        followUpQuestion.level = this.model.level + 1;
        return new WizardSegment(followUpQuestion);

    }
}
